module.exports = __webpack_public_path__ + "static/40-f190b157282c5091f20a48aebbfb8cab.jpg";